(function (dateUtils, $) {
  dateUtils.elDate = function (dateString) {
    var date = new Date(dateString);

    var dayOfMonth = $.datepicker.formatDate("d", date);
    var dayOfMonthWithNthSuffix = dayOfMonth + "<sup>" + getNthSuffix(parseInt(dayOfMonth)) + "</sup>";
    var formattedDate = dayOfMonthWithNthSuffix + $.datepicker.formatDate(" MM yy", date);

    return formattedDate;
  };

  function getNthSuffix(dayOfMonth) {
    switch (dayOfMonth) {
      case 1:
      case 21:
      case 31:
        return "st";
      case 2:
      case 22:
        return "nd";
      case 3:
      case 23:
        return "rd";
      default:
        return "th";
    }
  }

  var todaysDate = new Date();
  dateUtils.isToday = function (date) {
    return date.toDateString() === todaysDate.toDateString();
  };

  var oneDay = 24 * 60 * 60 * 1000;
  dateUtils.daysAgo = function (date) {
    return Math.round(Math.abs((date.getTime() - todaysDate.getTime()) / oneDay));
  };

  dateUtils.timeAgo = function (dateString) {
    var rightNow = new Date();
    var then = new Date(dateString);

    if (el.Utils.isIE()) {
      // IE can't parse these crazy Ruby dates
      then = Date.parse(dateString.replace(/( \+)/, " UTC$1"));
    }

    var diff = rightNow - then;

    var second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24,
      week = day * 7,
      month = week * 4;

    if (isNaN(diff) || diff < 0) {
      return ""; // return blank string if unknown
    }

    if (diff < second * 2) {
      // within 2 seconds
      return "right now";
    }

    var count;

    if (diff < minute) {
      count = Math.floor(diff / second);
      return count + getPlural(count, " second") + " ago";
    }

    if (diff < minute * 2) {
      return "about 1 minute ago";
    }

    if (diff < hour) {
      count = Math.floor(diff / minute);
      return count + getPlural(count, " minute") + " ago";
    }

    if (diff < hour * 2) {
      return "about 1 hour ago";
    }

    if (diff < day) {
      count = Math.floor(diff / hour);
      return count + getPlural(count, " hour") + " ago";
    }

    if (diff > day && diff < day * 2) {
      return "yesterday";
    }

    if (diff < day * 7) {
      count = Math.floor(diff / day);
      return count + getPlural(count, " day") + " ago";
    }

    if (diff < week * 4) {
      count = Math.floor(diff / week);
      return count + getPlural(count, " week") + " ago";
    }

    if (diff < month * 12) {
      count = Math.floor(diff / month);
      return count + getPlural(count, " month") + " ago";
    } else {
      return "over a year ago";
    }
  };

  function getPlural(count, word) {
    if (count === 1) {
      return word;
    }
    return word + "s";
  }
})((window.el.DateUtils = window.el.DateUtils || {}), jQuery);
